export const domains = {
  development: {
    nichesolv: "https://nichesolv.eks-be-dev.nichesolv.com",
    nds: "https://nds.eks-be-dev.nichesolv.com",
    lml: "https://lml.eks-be-dev.nichesolv.com",
    simpson: "https://simpson.eks-be-dev.nichesolv.com",
    "nds-dealer": "https://nds-dealer.eks-be-dev.nichesolv.com",
    lapa: "https://lapa.eks-be-preprod.nichesolv.com",
  },
  dev: {
    nichesolv: "https://nichesolv.ev-be-dev.nichesolv.com",
    nds: "https://nds.ev-be-dev.nichesolv.com",
    lml: "https://lml.ev-be-dev.nichesolv.com",
    simpson: "https://simpson.ev-be-dev.nichesolv.com",
    evdealer: "https://evdealer.ev-be-dev.nichesolv.com",
    lapa: "https://lapa.ev-be-preprod.nichesolv.com",
  },
  prod: {
    nichesolv: "https://nichesolv.ev-be.nichesolv.com",
    nds: "https://nds.ev-be.nichesolv.com",
    lml: "https://lml.ev-be.nichesolv.com",
    simpson: "https://simpson.ev-be.nichesolv.com",
    "nds-dealer": "https://nds-dealer.ev-be.nichesolv.com",
    lapa: "https://lapa.ev-be.nichesolv.com",
  },
  preProd: {
    nichesolv: "https://nichesolv.ev-be-preprod.nichesolv.com",
    nds: "https://nds.ev-be-preprod.nichesolv.com",
    lml: "https://lml.ev-be-preprod.nichesolv.com",
    simpson: "https://simpson.ev-be-preprod.nichesolv.com",
    "nds-dealer": "https://nds-dealer.ev-be-preprod.nichesolv.com",
    lapa: "https://lapa.ev-be-preprod.nichesolv.com",
  },
  eksPreProd: {
    nichesolv: "https://nichesolv.eks-be-preprod.nichesolv.com",
    nds: "https://nds.eks-be-preprod.nichesolv.com",
    lml: "https://lml.eks-be-preprod.nichesolv.com",
    simpson: "https://simpson.eks-be-preprod.nichesolv.com",
    "nds-dealer": "https://nds-dealer.eks-be-preprod.nichesolv.com",
  },
  eksDev: {
    nichesolv: "https://nichesolv.eks-be-dev.nichesolv.com",
    nds: "https://nds.eks-be-dev.nichesolv.com",
    lml: "https://lml.eks-be-dev.nichesolv.com",
    simpson: "https://simpson.eks-be-dev.nichesolv.com",
    "nds-dealer": "https://nds-dealer.eks-be-dev.nichesolv.com",
  },
};

export const gtmId = {
  development: "G-DEVELOPMENT",
  dev: "G-HGZ4C09FLJ",
  eksDev: "G-HGZ4C09FLJ",
  prod: "G-PN9T1CFM81",
  preProd: "G-3ZHEV2HR5B",
  eksPreProd: "G-3ZHEV2HR5B",
};

export const orgThemes = {
  default: {
    token: {
      colorPrimary: "#0392e2",
      colorLink: "#0392e2",
      evBgPrimaryTextColor: '#ffffff',
      colorPrimaryBgHover: '#d9d9d9',
      colorPrimaryBg: '#d9d9d9',
    },
    cssVar: true, 
  },
  nds: {
    token: {
      colorPrimary: "#f16521",
      colorLink: "#f16521",
      // fontSizeBase: '14px',
      // borderRadius: '4px',
      evBgPrimaryTextColor: '#ffffff',
      colorPrimaryBgHover: '#d9d9d9',
      colorPrimaryBg: '#d9d9d9',
    },
    cssVar: true, 
  },
  lml: {
    token: {
      colorPrimary: "#fe3241", //red
      colorLink: "#fe3241", //red
      // fontSizeBase: '14px',
      // borderRadius: '4px',
      evBgPrimaryTextColor: '#ffffff',
      colorPrimaryBgHover: '#d9d9d9',
      colorPrimaryBg: '#d9d9d9',
    },
    cssVar: true, 
  },
  simpson: {
    token: {
      colorPrimary: "#0392e2", //blue
      colorLink: "#0392e2", //blue
      // fontSizeBase: '14px',
      // borderRadius: '4px',
      evBgPrimaryTextColor: '#ffffff',
      colorPrimaryBgHover: '#d9d9d9',
      colorPrimaryBg: '#d9d9d9',
    },
    cssVar: true,
  },
  lapa: {
    token: {
      colorPrimary: "#616974", //black
      colorLink: "#777F88", //grey
      // fontSizeBase: '14px',
      // borderRadius: '4px',
      evBgPrimaryTextColor: '#ffffff',
      colorPrimaryBgHover: '#d9d9d9',
      colorPrimaryBg: '#00000029',
    },
    cssVar: true,
  }
}
